import EditForm from "./editForms/EditForm";
import { useEffect, useState } from "react";
import { leBleuItem } from "../data/LeBleu";
import { templateOneItems } from "../data/mainTemplate";
import { templateTwoItems } from "../data/templateTwo";
import { templateThreeItems } from "../data/templateThree";

function AddDashboard({restaurantName, activeDashboard, template}) {

    const [item, setItem] = useState({})

    useEffect(() => {
       {/*  IMPORTANT: IF WE START HAVING TOO MANY TEMPLATES THEN THIS MUST BE DYNAMIC! */}
        switch(template) {
            case "template-1": 
                setItem(templateOneItems)
            break;

            case "template-2":
                setItem(templateTwoItems)
            break;

            case "template-3":
                setItem(templateThreeItems);
        }
    }, [])


    return (
       
        <>  
            {Object.keys(item).length > 0 && 
                <EditForm 
                    restaurantName={restaurantName} 
                    item = {item} 
                    activeDashboard = {activeDashboard}
                />}
        </>
    )
}

export default AddDashboard;